stzh-dropdown {
  @include host;

  --color: #{$colorPrimary};
  --border-color: #{$formBorderColor};
  --label-color: #{$formColor};
  --placeholder-color: #{$formInputPlaceholderColor};
  --background-color: #{$colorWhite};
  --label-background: #{$colorWhite};
  --icon-size: #{iconSize('small')};
  --icon-angle-size: #{iconSize('medium')};

  --hover-color: #{$colorPrimaryHover};
  --hover-border-color: var(--hover-color);

  --popover-width: 100%;
  --popover-min-width: #{$popoverMinWidth};
  --popover-max-width: #{$popoverMinWidth};
  --popover-max-height: calc(6.5 * #{$menuItemHeight});

  --active-icon-angle-transform: rotate(180deg) translateY(50%);

  width: 100%;
  border-radius: $formInputBorderRadius;

  &[variant="plain"] {
    --background-color: transparent;
  }

  &[inline]:not([inline="false"]) {
    --popover-width: auto;
    width: auto;
  }

  &[size="small"] {
    --icon-angle-size: #{iconSize('small')};
  }

  /* Invalid */

  &[invalid]:not([invalid="false"]) {
    --color: #{$colorError};
    --border-color: #{$colorError};
    --label-color: #{$colorError};
    --placeholder-color: #{$colorError};

    --hover-color: #{$colorError};
    --hover-border-color: #{$colorError};
  }

  /* Disabled */

  &[disabled]:not([disabled="false"]) {
    --color: #{$formDisabledColor};
    --border-color: #{$formDisabledBorderColor};
    --label-color: #{$formDisabledColor};
    --placeholder-color: #{$formDisabledColor};
    --background-color: #{$formDisabledBackgroundColor};
    --label-background: transparent;

    --hover-color: #{$formDisabledColor};
    --hover-border-color: #{$formDisabledBorderColor};
  }

  &[disabled]:not([disabled="false"])[variant="plain"] {
    --background-color: transparent;
  }
}

.stzh-dropdown {
	@include input-description;

  .ts-hidden-accessible {
    @include visuallyhidden;
  }

  .ts-dropdown-content {
    max-height: var(--popover-max-height);
    overflow-y: auto;
    overflow-x: hidden;
    overflow-scrolling: touch;
    scroll-behavior: smooth;
  }

  .ts-control {
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    border-radius: $formInputBorderRadius;
    background-color: var(--background-color);
    transition-property: color, border-color;
    transition-duration: $baseTransitionAnimationSpeed;
    cursor: pointer;

    &:hover,
    &:focus-within {
      border-color: var(--hover-border-color);
    }

    & > * {
      vertical-align: baseline;
      display: inline-block;
    }
  }

  .ts-control,
  &__sizer {
    @include fontSize('milli');
    @include font;
    width: 100%;
    min-height: $formInputHeight;
    border: 1px solid var(--border-color);
  }

  .ts-control > input {
    font-size: inherit;
    line-height: inherit;
    flex: 1 1 auto;
    display: inline-block;
    padding: 0;
    min-height: 0;
    max-height: none;
    max-width: 100%;
    margin: 0;
    text-indent: 0;
    border: 0 none;
    background: none;
    user-select: auto;
    box-shadow: none;
    cursor: pointer;

    @include placeholder {
      color: var(--placeholder-color);
    }

    &::-ms-clear {
      display: none;
    }

    &:focus {
      outline: none;
    }

    &:placeholder-shown {
      text-overflow: ellipsis;
    }
  }

  &__vhidden {
    @include visuallyhidden;
  }

  &__field-wrapper,
  &__select {
    position: relative;
  }

  &__icon-wrapper {
    position: absolute;
  }

  &__select .ts-control > input,
  &__select.single &__item,
  &__icon-wrapper,
  &__icon-angle-wrapper {
    color: var(--color);
    transition: color $baseTransitionAnimationSpeed;
  }

  &__select.multi &__item {
    color: $colorPrimary;
  }

  &__select:hover .ts-control > input,
  &__select:focus-within .ts-control > input,
  &__select.single:hover &__item,
  &__select.single:focus-within &__item,
  &__select:hover ~ &__icon-wrapper,
  &__select:focus-within ~ &__icon-wrapper,
  &__select:hover ~ &__icon-angle-wrapper,
  &__select:focus-within ~ &__icon-angle-wrapper,
  &__select:hover ~ &__label,
  &__select:focus-within ~ &__label {
    color: var(--hover-color);
  }

  &__sizer {
    display: flex;
    align-items: center;
    margin-top: calc(#{$formInputHeight} / -1);
    pointer-events: none;
    visibility: hidden;
  }

  &__select.has-items ~ &__sizer {
    display: none;
  }

  &__select.plugin-input_hide ~ &__sizer {
    visibility: visible;
  }

  &__select.input-active .ts-control,
  &__select.input-active .ts-control > input {
    cursor: text;
  }

  &__select.input-hidden .ts-control > input,
  &__select.plugin-input_hide .ts-control > input {
    // hide input, while retaining its focus, and maintain layout so users can still click on the space to bring the display back
    // visibility:hidden can prevent the input from receiving focus
    opacity: 0;
    position: absolute;
    left: -10000px;
  }

  &__select.single .ts-control,
  &__select.multi .ts-control,
  &__sizer {
    padding: space('xsmall') space('medium');
    padding-right: calc(#{iconSize('medium')} + #{space('medium')} + #{space('xsmall')});
  }

  &__icon-wrapper,
  &__icon-angle-wrapper {
    display: flex;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    // transition-property: color, transform;
    // transition-duration: $baseTransitionAnimationSpeed;
  }

  &__icon-wrapper {
    left: space('medium');
  }

  &__icon-angle-wrapper {
    right: space('medium');
  }

  &__icon-wrapper stzh-icon,
  &__icon {
    --size: var(--icon-size);
  }

  &__icon-angle-wrapper stzh-icon,
  &__icon-angle {
    --size: var(--icon-angle-size);
  }

  &__label {
    @include font('heavy');
    @include fontSize('nano');
    @include truncate;
    color: var(--label-color);
    display: block;
    width: auto;
    position: absolute;
    top: calc(#{$formInputHeight} / 2);
    // padding-left (medium) + border-left
    left: calc(#{space('medium')} + 1px);
    max-width: calc(100% - #{space('medium')} * 2);
    transform: translateY(-50%);
    transition: all $baseTransitionAnimationSpeed;
    pointer-events: none;

    &:empty {
      display: none;
    }

    &::before {
      content: '';
      display: none;
      background: var(--label-background);
      position: absolute;
      width: 100%;
      z-index: -1;
      left: 0;
      top: 50%;
      // prevent white line not fully overlaping border of input
      height: 2px;
      margin-top: -0.5px;
    }
  }

  &__option,
  &__create {
    @include fontSize('micro');
    display: flex;
    align-items: center;
    justify-content: stretch;
    appearance: none;
    font-family: inherit;
    text-decoration-line: none;
    outline: none;
    border: none;
    padding: space('xsmall') space('medium');
    padding-left: space('large');
    color: $colorGrey70;
    height: $menuItemHeight;
    line-height: $menuItemHeight;
    transition: all $baseTransitionAnimationSpeed;
    cursor: pointer;

    &:hover,
    &.active {
      background-color: $colorGrey5;
    }

    &.selected {
      color: $colorPrimary;
    }

    &.selected:hover,
    &.selected.active {
      color: $colorPrimaryHover;
      background-color: $colorPrimary8;
    }

    // hide checkbox visually
    input {
      @include visuallyhidden;
    }
  }

  &__create {
    @include fontSize('micro');
    display: block;
  }

  &__option-title {
    @include truncate;
  }

  &__option[data-selectable] .highlight {
    @include font('heavy');
  }

  &__select &__option-check {
    display: none;
    color: $colorPrimary;
  }

  &__option.selected {
    // announce check when item is selected
    &::before {
      @include visuallyhidden;
      content: "✓";
    }
  }

  &__option.selected:hover &__option-check,
  &__option.selected.active &__option-check {
    color: $colorPrimaryHover;
  }

  &__no-results {
    @include wordWrap;
  }

  &__no-results,
  &__not-loading {
    @include fontSize('micro');
    padding: space('xsmall') space('medium');
    padding-left: space('large');
  }

  &__optgroup {

  }

  &__optgroup-header {
    cursor: default;
  }

  &__loader {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 38px;
  }

  &__dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    width: var(--popover-width);
    margin-top: space('xsmall');
    background-color: $colorWhite;
    box-shadow: $boxShadowPopover;
    z-index: $zIndexPopover;
    border-radius: $popoverBorderRadius;
    overflow: hidden;

    @include mq($from: small) {
      min-width: var(--popover-min-width);
      max-width: var(--popover-max-width);
    }
  }

  /* Plugin: Input autogrow */

  &__select.plugin-input_autogrow.has-items .ts-control > input {
    min-width: 0;
  }

  &__select.plugin-input_autogrow.has-items.focus .ts-control > input {
    flex: none;
    min-width: 4px;
  }

  /* Has Items */

  &__select.has-items .ts-control > input {
    margin: 0 4px;

    @include placeholder {
      color: transparent;
    }
  }

  /* Is Open */

  &__select.dropdown-active ~ &__icon-angle-wrapper {
    transform: var(--active-icon-angle-transform);
  }

  /* Multiple variant */

  &--is-multiple &__option-check {
    display: inline-flex;
    opacity: 0;
    transition: opacity $baseTransitionAnimationSpeed;
    margin-right: space('xsmall');
  }

  &--is-multiple &__option {
    padding-left: space('small');
  }

  &--is-multiple &__option.selected &__option-check {
    opacity: 1;
  }

  &--is-multiple &__select.multi.has-items .ts-control {
    padding-top: calc(#{space('xsmall')} - 1px);
    padding-bottom: calc(#{space('xsmall')} - 1px);
  }

  &--is-multiple &__select.multi &__item {
    @include fontSize('micro');
    position: relative;
    height: 24px;
    line-height: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 12px;
    padding: 0 space('medium');
    appearance: none;
    font-family: inherit;
    border: 1px solid transparent;
    background-color: $colorGrey5;
    transition: all $baseTransitionAnimationSpeed;
    margin: space('xxsmall') space('xxsmall') space('xxsmall') 0;
    cursor: pointer;

    &:hover {
      color: $colorPrimaryHover;
      background-color: $colorPrimary8;
    }

    &.active {
      color: $colorWhite;
      background-color: $colorPrimary;
    }
  }

  /* Plugin: Remove button */

  &--is-multiple &__select.plugin-remove_button &__item {
    display: inline-flex;
    align-items: center;
    padding-right: calc(24px + #{space('xxsmall')});
  }

  &--is-multiple &__select.plugin-remove_button &__item .remove {
    position: absolute;
    top: 50%;
    right: -1px; // -1px to overlap border
    transform: translateY(-50%);
    text-decoration-line: none;
    width: 24px;
    height: 24px;
    border-radius: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: space('xxsmall');
    color: $baseLeadColor;
    transition: all $baseTransitionAnimationSpeed;

    &:hover {
      color: $colorPrimaryHover;
      background-color: $colorPrimary8;
    }
  }

  &--is-multiple &__select.plugin-remove_button &__remove-icon {
    --size: #{iconSize('xxsmall')};
  }

  &--is-multiple &__select.plugin-remove_button &__item.active &__remove-icon {
    color: $colorWhite;
  }

  /* Popover placement */

  &--popover-placement-top &__dropdown,
  &--popover-placement-top-end &__dropdown,
  &--popover-placement-top-center &__dropdown {
    margin-top: 0;
    top: auto;
    bottom: 100%;
    margin-bottom: space('xsmall');
  }

  &--popover-placement-top#{&}--plain &__dropdown,
  &--popover-placement-top-end#{&}--plain &__dropdown,
  &--popover-placement-top-center#{&}--plain &__dropdown {
    margin-bottom: 0;
  }

  &--popover-placement-top-end &__dropdown,
  &--popover-placement-bottom-end &__dropdown {
    left: auto;
    right: 0;
  }

  &--popover-placement-top-center &__dropdown,
  &--popover-placement-bottom-center &__dropdown {
    left: 50%;
    transform: translateX(-50%);
  }

  /* Hidden label */
  &--has-label-hidden &__label {
    @include visuallyhidden;
  }

  /* Small */

  &--size-small .ts-control,
  &--size-small &__sizer {
    @include fontSize('micro');
  }

  &--size-small .ts-control {
    min-height: $formInputHeightSmall;
  }

  &--size-small &__sizer {
    min-height: initial;
    height: $formInputHeightSmall;
    margin-top: calc(#{$formInputHeightSmall} / -1);
  }

  &--size-small &__label {
    top: calc(#{$formInputHeightSmall} / 2);
  }

  &--size-small &__select.single .ts-control,
  &--size-small &__select.multi .ts-control,
  &--size-small &__sizer {
    padding: space('xxsmall') space('medium');
    padding-right: calc(#{iconSize('small')} + #{space('medium')} + #{space('xsmall')});
  }

  /* Has icon */

  &--has-icon &__select.single .ts-control,
  &--has-icon &__select.multi .ts-control,
  &--has-icon &__sizer {
    padding-left: calc(var(--icon-size) + #{space('medium')} + #{space('xsmall')});
  }

  &--has-icon &__label {
    left: calc(var(--icon-size) + #{space('medium')} + #{space('xsmall')} + 1px);
  }

  /* Plain */

  &--plain &__select.single .ts-control,
  &--plain &__select.multi .ts-control,
  &--plain &__sizer {
    border: none;
    padding-left: 0;
    padding-right: calc(#{iconSize('medium')} + #{space('xsmall')});
  }

  &--plain &__icon-wrapper {
    left: 0;
  }

  &--plain &__icon-angle-wrapper {
    right: 0;
  }

  &--plain &__label {
    left: 0;
    max-width: 100%;
    padding: 0;

    &::before {
      content: none;
    }
  }

  &--plain &__dropdown {
    margin-top: 0;
  }

  &--plain#{&}--size-small &__select.single .ts-control,
  &--plain#{&}--size-small &__select.multi .ts-control,
  &--plain#{&}--size-small &__sizer {
    padding-right: calc(#{iconSize('small')} + #{space('xsmall')});
  }

  &--plain#{&}--has-icon &__select.single .ts-control,
  &--plain#{&}--has-icon &__select.multi .ts-control,
  &--plain#{&}--has-icon &__sizer {
    padding-left: calc(var(--icon-size) + #{space('xsmall')});
  }

  &--plain#{&}--has-icon &__label {
    left: calc(var(--icon-size) + #{space('xsmall')} + 1px);
  }

  /* Styles for floating label */

  &--has-fixed-label &__label,
  &--is-filled &__label,
  &--is-disabled &__label,
  &--is-invalid &__label,
  &--has-focus &__label {
    top: 0;
    // padding-left (input field medium) - padding-left
    left: calc(#{space('medium')} - #{space('xxsmall')});
    height: 20px; // dividable by two (so before element is always positioned correctly)
    line-height: 20px;
    padding: 0 space('xxsmall');
    max-width: calc(100% - (#{space('medium')} - #{space('xxsmall')}) * 2);
    pointer-events: all;

    &:not(:empty)::before {
      display: block;
    }
  }

  &--plain#{&}--has-fixed-label &__label,
  &--plain#{&}--is-filled &__label,
  &--plain#{&}--is-disabled &__label,
  &--plain#{&}--is-invalid &__label,
  &--plain#{&}--has-focus &__label {
    left: 0;
    padding: 0;
    max-width: 100%;
  }

  /* Has no search */

  &--has-no-search .ts-control > input {
    position: absolute;
    width: 0px;
    height: 0px;
  }

  &--has-no-search &__select.input-active .ts-control,
  &--has-no-search &__select.input-active .ts-control > input {
    cursor: pointer;
  }

  /* Disabled */

  &--is-disabled &__select.multi &__item,
  &--is-disabled &__select.plugin-remove_button &__item .remove {
    cursor: not-allowed;
  }

  &--is-disabled &__select.multi &__item,
  &--is-disabled &__select.multi &__item:hover {
    color: $colorGrey25;
    background-color: $colorWhite;
    border-color: $baseBorderColor;
  }

  &--is-disabled &__select.plugin-remove_button &__item .remove,
  &--is-disabled &__select.plugin-remove_button &__item .remove:hover {
    color: $colorGrey13;
    background-color: transparent;
  }
}
